// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__tj7n6","author":"Table_author__3A9wU","authorImage":"Table_authorImage__1WGBh","unreadRow":"Table_unreadRow__2ni21"};